export default function PaintSplatter({
  position = "top-left",
  size = "md",
  opacity = 0.2,
  rotation = 0,
  className = "",
}) {
  // Define colors directly in the component
  const colors = {
    primary: "#7749F8",
    primaryDark: "#6438E4",
    secondary: "#FFBA07",
  }

  const getPositionStyle = () => {
    switch (position) {
      case "top-left":
        return { top: 0, left: 0 }
      case "top-right":
        return { top: 0, right: 0 }
      case "bottom-left":
        return { bottom: 0, left: 0 }
      case "bottom-right":
        return { bottom: 0, right: 0 }
      case "center-left":
        return { top: "50%", left: 0, transform: `translateY(-50%) rotate(${rotation}deg)` }
      case "center-right":
        return { top: "50%", right: 0, transform: `translateY(-50%) rotate(${rotation}deg)` }
      default:
        return { top: 0, left: 0 }
    }
  }

  const getSizeStyle = () => {
    switch (size) {
      case "sm":
        return { width: "6rem", height: "6rem" }
      case "md":
        return { width: "10rem", height: "10rem" }
      case "lg":
        return { width: "16rem", height: "16rem" }
      case "xl":
        return { width: "24rem", height: "24rem" }
      default:
        return { width: "10rem", height: "10rem" }
    }
  }

  const positionStyle = getPositionStyle()
  const sizeStyle = getSizeStyle()

  const style = {
    position: "absolute",
    opacity,
    zIndex: 0,
    pointerEvents: "none",
    ...positionStyle,
    ...sizeStyle,
  }

  if (!positionStyle.transform) {
    style.transform = `rotate(${rotation}deg)`
  }

  const splatterStyle = {
    width: "100%",
    height: "100%",
    backgroundColor: colors.secondary,
    borderRadius: "50%",
    filter: "blur(1rem)",
  }

  return (
    <div style={style} className={className}>
      <div style={splatterStyle}></div>
    </div>
  )
}

